import grid1 from '../src/Images/img-grid-1.jpg'
import grid2 from '../src/Images/img-grid-2.jpg'
import grid3 from '../src/Images/img-grid-3.jpg'
import Footer from './Footer'

const Services = () =>{
    return(
        <div>

{/* <!-- Start We Help Section --> */}
		<div class="we-help-section">
			<div class="container">
				<div class="row justify-content-between">
					<div class="col-lg-7 mb-5 mb-lg-0">
						<div class="imgs-grid">
							<div class="grid grid-1"><img src={grid1} alt="Untree.co"/></div>
							<div class="grid grid-2"><img src={grid2} alt="Untree.co"/></div>
							<div class="grid grid-3"><img src={grid3} alt="Untree.co"/></div>
						</div>
					</div>
					<div class="col-lg-5 ps-lg-5">
						<h2 class="section-title mb-4">We Help You Make Modern Interior Design</h2>
						<p>Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. Pellentesque habitant morbi tristique senectus et netus et malesuada</p>

						<ul class="list-unstyled custom-list my-4">
							<li>Donec vitae odio quis nisl dapibus malesuada</li>
							<li>Donec vitae odio quis nisl dapibus malesuada</li>
							<li>Donec vitae odio quis nisl dapibus malesuada</li>
							<li>Donec vitae odio quis nisl dapibus malesuada</li>
						</ul>
						<p><a herf="#" class="btn">Explore</a></p>
					</div>
				</div>
			</div>
		</div>
		{/* <!-- End We Help Section --> */}

        

        </div>
    )
}

export default Services;